// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"94ef3ac0","113":"a959eb82","164":"07887ca3","213":"efdf2d78","354":"6c2461fb","455":"3f4a07b6","481":"70d8ee0b","488":"f1dc7667","513":"8e2ad02d","746":"72a351fc","890":"8569fb31","941":"efdc8f27","946":"3120d0bd"}[chunkId] + ".chunk.js";
};